module.exports = __webpack_public_path__ + "static/img/5.709ac55.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/1/zh/5.png
// module id = 1R5t
// module chunks = 0